module.exports = __webpack_public_path__ + "static/media/battery-mr-card-front.c55eb779.jpeg";